/**
 * @desc 发布预告公告
 */
import { AnnouncementPublishForm } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type PublishAnnouncementParameter = AnnouncementPublishForm

const method = 'PUT'
const url = '/trade/operation/announcement/public'

export const publishAnnouncementApi = (
  data?: PublishAnnouncementParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

publishAnnouncementApi.method = method
publishAnnouncementApi.url = url
